import React from 'react';
import './ValidationError.css';

const ValidationError = ({ message }) => {
    if (!message) return null;
    return <div className="validation-error">{message}</div>;
};

export default ValidationError;
